import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row p-2" }
const _hoisted_2 = { class: "col-12 d-flex" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "font-weight-bold mb-0" }
const _hoisted_5 = { class: "text-muted mr-1" }
const _hoisted_6 = { class: "col-6 text-left" }
const _hoisted_7 = { class: "col-6 text-right" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-4 text-center" }
const _hoisted_13 = { class: "mb-0 txt-bold" }
const _hoisted_14 = {
  style: {"border-color":"#e4eaf0","border-style":"solid","border-width":"0 1px"},
  class: "col-4 text-center"
}
const _hoisted_15 = { class: "mb-0 txt-bold" }
const _hoisted_16 = { class: "col-4 text-center" }

import { ref } from "vue";
import ChartCustome from "../chart/ChartCustome.vue";
import AlertPopup from "../popup/AlertPopup.vue";
import { useRouter } from "vue-router";
import { NTag, NTooltip, NIcon, NPopover } from "naive-ui";
import { normalizeFloat } from "@app/@turnkeyidutils";

interface IProps {
  data?: any;
  type?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InvestmentCard',
  props: {
    data: {},
    type: {}
  },
  setup(__props: any) {

const router = useRouter();
const isOpen = ref(false);

const props = __props;

const profile_pic_url = ref(props.data.manager.persona.profile_pic_url);
const owner = ref(props.data.manager.owner);
const investor_detail = ref(props.data.account.investor_detail);
function toLink(data) {
  if (data.status === `pending`) {
    isOpen.value = true;
    return;
  }
  if (data.status === `pending-disconnect`) {
    return;
  }
  router.push(`/pamm/investor-account/my-investment/${data.id ? data.id : data._id}`);
}

function countGrowth(data: any): number {
  const balance = data.account && data.account.investor_detail && data.account.investor_detail.Balance ? data.account.investor_detail.Balance : 0;
  const totalProfit = data.account && data.account.investor_detail && data.account.investor_detail.TotalProfit ? data.account.investor_detail.TotalProfit : 0;
  if (balance && totalProfit) {
    return Number(((totalProfit / balance) * 100).toFixed(2));
  }
  return 0;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "my-investment-card h-100 p-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toLink(__props.data)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-12" }, "Me connected to:", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: profile_pic_url.value ? profile_pic_url.value : '/assets/img/avatar.svg',
            class: "rounded-circle bg-secondary mr-3",
            alt: __props.data?.manager?.manager_detail?.Name,
            style: {"width":"40px","height":"40px"}
          }, null, 8, _hoisted_3),
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(__props.data?.manager?.manager_detail?.Name), 1),
            _createElementVNode("small", _hoisted_5, " ID : " + _toDisplayString(__props.data?.manager?.manager_detail?.Id || "-"), 1),
            _createElementVNode("span", null, [
              _createVNode(_unref(NTag), {
                class: "mt-2",
                round: "",
                size: "small",
                bordered: false,
                type: __props.data.status === 'connected' ? 'success' : __props.data.status === 'disconnected' ? 'error' : __props.data.status === 'pending' ? 'warning' : 'default'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.data.status), 1)
                ]),
                _: 1
              }, 8, ["type"]),
              (__props.data.status === `pending-disconnect` || __props.data.status === `pending`)
                ? (_openBlock(), _createBlock(_unref(NPopover), {
                    key: 0,
                    trigger: "hover",
                    placement: "right"
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NIcon), { class: "ml-2" }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "please wait for money manager approval", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-secondary" }, "Total Profit", -1)),
          _createElementVNode("p", {
            class: _normalizeClass([investor_detail.value.TotalProfit >= 0 ? 'profit' : 'text-danger', "mb-0 txt-bold"])
          }, _toDisplayString(_unref(normalizeFloat)(investor_detail.value.TotalProfit || 0, {
              toFixed: 2,
            })) + " USD ", 3)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-secondary" }, "Growth", -1)),
          _createElementVNode("p", {
            class: _normalizeClass([countGrowth(__props.data) >= 0 ? 'profit' : 'text-danger', "mb-0 txt-bold"])
          }, [
            _createElementVNode("img", {
              src: countGrowth(__props.data) < 0 ? `/assets/img/trending_down.svg` : '/assets/img/trending_up.svg',
              alt: "trending"
            }, null, 8, _hoisted_8),
            _createTextVNode(" " + _toDisplayString(countGrowth(__props.data)) + "% ", 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(ChartCustome, {
            type: "lineChart",
            data: __props.data.performanceHistory,
            "is-profit": countGrowth(__props.data) >= 0
          }, null, 8, ["data", "is-profit"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("small", _hoisted_13, _toDisplayString(_unref(normalizeFloat)(__props.data?.invest_summary?.t4b_total_deposit || 0, {
                  toFixed: 2,
                })) + " USD", 1),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-secondary" }, "Total Deposit", -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("small", _hoisted_15, _toDisplayString(_unref(normalizeFloat)(investor_detail.value.Equity || 0, {
                  toFixed: 2,
                })) + " USD", 1),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-secondary" }, "Equity", -1))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("small", {
                class: _normalizeClass([__props.data?.invest_summary?.t4b_total_withdraw >= 0 ? 'text-success' : 'text-danger', "mb-0 txt-bold"])
              }, _toDisplayString(_unref(normalizeFloat)(__props.data?.invest_summary?.t4b_total_withdraw || 0, {
                  toFixed: 2,
                })) + " USD ", 3),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-secondary" }, "Total Withdraw", -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(AlertPopup, {
      "is-open": isOpen.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = $event))
    }, null, 8, ["is-open"])
  ], 64))
}
}

})